












import Vue from "vue";
import Component from "vue-class-component";

@Component({
  metaInfo: {
    title: "Event Created – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Your event has been created and is pending moderator approval." },
      { vmid: "og:title", property: "og:title", content: "Event Created – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Your event has been created and is pending moderator approval." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/events/success" },
    ],
  },
})
export default class EventEditor extends Vue {
  public progress: number = 100;

  public mounted() {
    this.updateProgress();
  }

  public updateProgress() {
    setTimeout(() => {
      this.progress -= 0.5;
      if (this.progress <= 0) {
        this.$router.push("/");
      } else {
        this.updateProgress();
      }
    }, 100);
  }
}
